import { useTheme } from "../../../context/theme";
import { ColorRole, ContentEmphasis, KeyColorRole } from "../types";

export function useContentColor({
  tone,
  emphasis,
  onHighEmphasisSurface
}: {
  tone?: KeyColorRole;
  emphasis: ContentEmphasis;
  onHighEmphasisSurface: boolean;
}) {
  const theme = useTheme();

  if (!tone) return undefined;

  let role: ColorRole;

  if (onHighEmphasisSurface) {
    role = `contentOn-${tone}-high-surface`;
  } else {
    role = `${tone}-${emphasis}-content`;
  }

  return theme[role];
}
